"use client";

import React from "react";
import { Loader2 } from "lucide-react";

// لودر اصلی برای دکمه‌ها
export const Spinner = () => <Loader2 className="h-5 w-5 animate-spin" />;

// لودر مخصوص گوگل با طراحی متفاوت
export const GoogleSpinner = () => (
    <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);

export const inputBaseClasses = "w-full pr-10 pl-3 py-2.5 rounded-lg border bg-transparent text-zinc-900 dark:text-zinc-100 placeholder-zinc-400 dark:placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-blue-500";
export const inputErrorClasses = "border-red-500 ring-1 ring-red-500";
export const inputDefaultClasses = "border-zinc-300 dark:border-zinc-600";
export const buttonClasses = "w-full h-14 flex items-center justify-center gap-2 rounded-lg bg-blue-600 text-white text-lg font-semibold hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400 disabled:cursor-not-allowed";

export const FADE_IN_VARIANTS = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: "easeOut" } },
    exit: { opacity: 0, y: -10, transition: { duration: 0.2, ease: "easeIn" } }
};
